import getWithToken from './base/get-with-token'

const getCustomerConsumptionUsage = id => getWithToken(`/customer/${id}/historical-water-usage`)

export default getCustomerConsumptionUsage
